// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lFHV","index":"styles_index__2ZuBZ"};